import { makeImmutable } from "../../core/makeImmutable";
export class WholeOrderPromotionScope {
    constructor(params) {
        this.kind = "WholeOrder";
        this.selector = params.selector;
        makeImmutable(this);
    }
}
